import { render, staticRenderFns } from "./DeleteDataDuplicate.vue?vue&type=template&id=1d8f33d7&scoped=true"
import script from "./DeleteDataDuplicate.vue?vue&type=script&lang=js"
export * from "./DeleteDataDuplicate.vue?vue&type=script&lang=js"
import style0 from "./DeleteDataDuplicate.vue?vue&type=style&index=0&id=1d8f33d7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8f33d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d8f33d7')) {
      api.createRecord('1d8f33d7', component.options)
    } else {
      api.reload('1d8f33d7', component.options)
    }
    module.hot.accept("./DeleteDataDuplicate.vue?vue&type=template&id=1d8f33d7&scoped=true", function () {
      api.rerender('1d8f33d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/dialog/DeleteDataDuplicate.vue"
export default component.exports